import axios from "axios";
import { authenticatedApiConfig, generateURL } from "./BaseApiService";
export class SHLService {
    constructor(authenticationProvider, environment) {
        this.authenticationProvider = authenticationProvider;
        this.environment = environment;
    }
    async createSHL(patientId, createSHLDto) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/shl", { patientId }), createSHLDto, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getSHLsForPatient(patientId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/shl", { patientId }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getSHLById(patientId, shlId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/shl/:shlId", { patientId, shlId }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async revokeSHL(patientId, shlId) {
        const response = await axios.post(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/shl/:shlId/revoke", { patientId, shlId }), {}, await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
    async getSHLAccessLog(patientId, shlId) {
        const response = await axios.get(generateURL(this.environment.API_BASE_URL, "/patients/:patientId/shl/:shlId/access-log", { patientId, shlId }), await authenticatedApiConfig(this.authenticationProvider));
        return response.data;
    }
}
